import React, {Fragment, type RefObject} from "react";
import {scroller} from "react-scroll";
import cn from "classnames";
import type {Property} from "csstype";

import {capitalize, noop} from "@pg-mono/nodash";

import type {ITab} from "../types/ITab";
import type {TabsActiveColor} from "../types/TabsActiveColor";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsTheme} from "../types/TabsTheme";
import type {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

export type IProps<ValueType extends TabsAllowedValueTypes> = {
    activeColor?: TabsActiveColor;
    className?: string;
    fullWidth?: boolean;
    fullWidthBorder?: boolean;
    onChange?: (value: ValueType) => void;
    tabs: ITab<ValueType>[];
    titlesMaxWidth?: Property.MaxWidth;
    theme?: TabsTheme;
    value?: ValueType;
    variant?: TabsVariant;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
};

type ClassName = keyof typeof styles;

const getTilesVariant = (variant: TabsVariant) => `tiles${capitalize(variant)}` as ClassName;
const getFullWidthBorder = (color: TabsActiveColor) => `tabsFullWidthBorder${colorToClassName(color)}` as ClassName;

export const Tabs = <ValueType extends TabsAllowedValueTypes>(props: IProps<ValueType>) => {
    const {theme = "gray", variant = "contained"} = props;

    const onClick = (value: ValueType, scrollRef?: RefObject<HTMLElement>, scrollId?: string, scrollOffset?: number) => {
        props.onChange?.(value);

        if (scrollId && scrollOffset) {
            scroller.scrollTo(scrollId, {offset: scrollOffset, smooth: true});
        }

        if (scrollRef && scrollRef.current) {
            scrollRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        }
    };

    const classes = cn(
        styles.tabs,
        props.fullWidthBorder && styles.tabsFullWidthBorder,
        styles[getFullWidthBorder(props.activeColor || theme)],
        props.className
    );

    return (
        <div className={classes}>
            <div style={props.titlesMaxWidth ? {maxWidth: props.titlesMaxWidth} : noop()}>
                <div className={cn(styles.tiles, props.fullWidth && styles.wFull, styles[getTilesVariant(variant)])}>
                    {props.tabs.map((tab, index) => {
                        const active = typeof props.value !== "undefined" ? props.value === tab.value : false;

                        const titleElement = (
                            <Title
                                key={tab.value}
                                active={active}
                                activeColor={props.activeColor}
                                fullWidth={props.fullWidth}
                                onClick={() => onClick(tab.value, tab.scrollRef, tab.scrollId, tab.scrollOffset)}
                                theme={theme}
                                variant={variant}
                            >
                                {tab.title}
                            </Title>
                        );

                        return props.customRenderer ? props.customRenderer(tab, titleElement, index) : titleElement;
                    })}
                </div>
            </div>

            {props.tabs.map((tab) => {
                return props.value === tab.value ? <Fragment key={`tc${tab.value}`}>{tab.content}</Fragment> : null;
            })}
        </div>
    );
};
import React, {Fragment, type RefObject} from "react";
import {scroller} from "react-scroll";
import cn from "classnames";
import type {Property} from "csstype";

import {capitalize, noop} from "@pg-mono/nodash";

import type {ITab} from "../types/ITab";
import type {TabsActiveColor} from "../types/TabsActiveColor";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsTheme} from "../types/TabsTheme";
import type {TabsVariant} from "../types/TabsVariant";
import {colorToClassName} from "../utils/color_to_class_name";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

export type IProps<ValueType extends TabsAllowedValueTypes> = {
    activeColor?: TabsActiveColor;
    className?: string;
    fullWidth?: boolean;
    fullWidthBorder?: boolean;
    onChange?: (value: ValueType) => void;
    tabs: ITab<ValueType>[];
    titlesMaxWidth?: Property.MaxWidth;
    theme?: TabsTheme;
    value?: ValueType;
    variant?: TabsVariant;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
};

type ClassName = keyof typeof styles;

const getTilesVariant = (variant: TabsVariant) => `tiles${capitalize(variant)}` as ClassName;
const getFullWidthBorder = (color: TabsActiveColor) => `tabsFullWidthBorder${colorToClassName(color)}` as ClassName;

export const Tabs = <ValueType extends TabsAllowedValueTypes>(props: IProps<ValueType>) => {
    const {theme = "gray", variant = "contained"} = props;

    const onClick = (value: ValueType, scrollRef?: RefObject<HTMLElement>, scrollId?: string, scrollOffset?: number) => {
        props.onChange?.(value);

        if (scrollId && scrollOffset) {
            scroller.scrollTo(scrollId, {offset: scrollOffset, smooth: true});
        }

        if (scrollRef && scrollRef.current) {
            scrollRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        }
    };

    const classes = cn(
        styles.tabs,
        props.fullWidthBorder && styles.tabsFullWidthBorder,
        styles[getFullWidthBorder(props.activeColor || theme)],
        props.className
    );

    return (
        <div className={classes}>
            <div style={props.titlesMaxWidth ? {maxWidth: props.titlesMaxWidth} : noop()}>
                <div className={cn(styles.tiles, props.fullWidth && styles.wFull, styles[getTilesVariant(variant)])}>
                    {props.tabs.map((tab, index) => {
                        const active = typeof props.value !== "undefined" ? props.value === tab.value : false;

                        const titleElement = (
                            <Title
                                key={tab.value}
                                active={active}
                                activeColor={props.activeColor}
                                fullWidth={props.fullWidth}
                                onClick={() => onClick(tab.value, tab.scrollRef, tab.scrollId, tab.scrollOffset)}
                                theme={theme}
                                variant={variant}
                            >
                                {tab.title}
                            </Title>
                        );

                        return props.customRenderer ? props.customRenderer(tab, titleElement, index) : titleElement;
                    })}
                </div>
            </div>

            {props.tabs.map((tab) => {
                return props.value === tab.value ? <Fragment key={`tc${tab.value}`}>{tab.content}</Fragment> : null;
            })}
        </div>
    );
};
